import styled from 'styled-components';

export const Container = styled.iframe`
  width: 100%;
  flex: 1;
  border: none;
`;
